export function parseVCFForReference(vcfContent) {
  const lines = vcfContent.split("\n");
  const headerLines = lines.filter((line) => line.startsWith("##"));
  // Check reference line
  const referenceLine = headerLines.find((line) =>
    line.startsWith("##reference=")
  );

  // Check contig lines for reference-specific patterns
  const contigLines = headerLines.filter((line) =>
    line.startsWith("##contig=")
  );

  const allHeaderText = headerLines.join("\n").toLowerCase();

  // Look for hg38 indicators
  const hg38Indicators = [
    "hg38",
    "GRCh38",
    "grch38",
    "assembly=GRCh38",
    "assembly=hg38",
    "genome=hg38",
    "genome=GRCh38",
  ];

  // Look for hg19 indicators
  const hg19Indicators = [
    "hg19",
    "GRCh37",
    "grch37",
    "assembly=GRCh37",
    "assembly=hg19",
    "genome=hg19",
    "genome=GRCh37",
    "b37",
    "build37",
  ];

  const hasHg38Reference = hg38Indicators.some((indicator) =>
    allHeaderText.includes(indicator.toLowerCase())
  );

  const hasHg19Reference = hg19Indicators.some((indicator) =>
    allHeaderText.includes(indicator.toLowerCase())
  );

  return {
    hasHg38Reference,
    hasHg19Reference,
    referenceLine,
    contigCount: contigLines.length,
    detectionMethod:
      hasHg38Reference || hasHg19Reference ? "header_text" : "unknown",
  };
}
